var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTables = function SvgTables(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8V7c0-.8-.667-1-1-1H4c-.333 0-1 .2-1 1v1c0 .333.2 1 1 1h16c.8 0 1-.667 1-1ZM8 12h8M5 9v10.5c0 .333.2 1 1 1h1c.333 0 1-.2 1-1V9M16 9v10.5c0 .333.2 1 1 1h1c.333 0 1-.2 1-1V9",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
export default SvgTables;